export default "__VITE_ASSET__532139cf__"